<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link href="https://www.taobao2you.com" class="brand-logo" >
        <!-- <vuexy-logo /> -->
        <b-img
          class="d-none d-sm-block"
          :src="require('@/assets/logo-taobao/Profile.jpg')"
          fluid
          width="50px"
          height="30px"
        >
        </b-img>
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">
          TAOBAO2YOU
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            style="width:100%"
            fluid
            :src="require('@/assets/taobao2you+no1.png')"
            alt="Login taobao"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
          <b-img
            class="d-block d-sm-none "
            style="width:100%"
            fluid
            :src="require('@/assets/taobao2you+no1.png')"
            alt="Login taobao"
          />
            เข้าสู่ระบบสำหรับ Admin
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="loginButton"
            >
              <!-- email -->
              <b-form-group
                label="Username"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="user"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="Username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="pass"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid || loadButton == false"
                @click="loginButton()"
              >
                <b-spinner v-if="loadButton == false" small />
                เข้าสู่ระบบ
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
import { token_api, header_token } from '@/views/token'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
  BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BCard, BSpinner, VBTooltip
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  props:{
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
    BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BCard, BSpinner,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: 'admin',
      userEmail: 'admin@demo.com',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
      profile: [],
      user: '',
      pass: '',

      loadButton: true,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },

  methods: {
    async loginButton(){
      this.loadButton = await false
      var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
      var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
      // var abi = [{action: "read", subject: "dashboard"}]
      this.profile = []
      let response = await axios.post(taobaoService_dotnet  + 'app/Customer/admin-login',
      {
        'username': this.user,
        'password': this.pass
      },
      { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }})
      this.$refs.loginForm.validate().then( async success => {
        if( response.data.message == 'success' ) {
          if (success) {
            await this.profile.push({
              'data': response.data,
              'role': 'admin',
              'ability': [
                {action: "manage", subject: "TaobaoAdmin"},
                ]
            })
            useJwt.setToken(sToken)
            useJwt.setRefreshToken(rToken)
            localStorage.setItem('userData', JSON.stringify(this.profile[0]))
            localStorage.setItem('adminId', JSON.stringify(this.profile[0].data.adminInfo.userID))
            this.$ability.update(this.profile[0].ability)

            this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', 0)

            this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))

            this.loadButton = true

          }
        } else {
          this.$swal({
            position: 'top',
            title: 'ล็อคอินไม่สำเร็จ',
            text: 'Username หรือ รหัสผ่านผิด',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
              text: 'text-danger'
            },
            buttonsStyling: false,
          })
          this.loadButton = true
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style>

</style>
